var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentityCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 47,
    viewBox: "0 0 53 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7902 30.7333V42.609C46.7902 44.2108 45.4909 45.5102 43.889 45.5102H3.90115C2.29932 45.5102 1 44.2108 1 42.609V14.6902C1 13.0884 2.29932 11.7891 3.90115 11.7891H25.2374",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2885 39.6431H9.57639C8.1564 39.6431 7.00586 38.4925 7.00586 37.0725V36.5584C7.00586 32.7729 10.0756 29.7031 13.8612 29.7031H18.0038C21.7893 29.7031 24.8591 32.7729 24.8591 36.5584V37.0725C24.8591 38.4909 23.7085 39.6431 22.2885 39.6431Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9296 29.703C18.9369 29.703 21.3748 27.265 21.3748 24.2577C21.3748 21.2504 18.9369 18.8125 15.9296 18.8125C12.9223 18.8125 10.4844 21.2504 10.4844 24.2577C10.4844 27.265 12.9223 29.703 15.9296 29.703Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.772 33.6836H30.7812",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7827 39.6426H30.7832",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.73 29.2114C47.258 26.173 50.212 20.9113 50.212 20.9113C53.0255 16.043 51.675 5.78069 51.675 5.78069C45.1751 4.96407 40.73 1 40.73 1C40.73 1 36.2848 4.96407 29.785 5.77904C29.785 5.77904 28.4344 16.043 31.2479 20.9096C31.2479 20.9113 34.202 26.173 40.73 29.2114Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.498 15.2559L39.5852 18.8089L47.498 11.2559",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityCheckIcon);
export default __webpack_public_path__ + "static/media/identityCheckIcon.12290d36960097ea429b73a9d04c06c5.svg";
export { ForwardRef as ReactComponent };